import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 40px;
  min-width: 400px;
`;

export const Title = styled.h3`
  margin-bottom: 20px;
  color: #333;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 20px;
  color: #666;
  display: flex;
  flex-direction: column;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
